export const GET_CANDIDATEBOARD_FOR_CANDIDATE = "GET_CANDIDATEBOARD_FOR_CANDIDATE"
export const GET_CANDIDATEBOARD = "GET_CANDIDATEBOARD"
export const UPDATE_CANDIDATEBOARD_FOR_CANDIDATE = "UPDATE_CANDIDATEBOARD_FOR_CANDIDATE"
export const ADD_CANDIDATEBOARD_TO_CANDIDATE = "ADD_CANDIDATEBOARD_TO_CANDIDATE"
export const REMOVE_CANDIDATEBOARD_FROM_CANDIDATE = "REMOVE_CANDIDATEBOARD_FROM_CANDIDATE"
export const CLEAR_CANDIDATEBOARD = "CLEAR_CANDIDATEBOARD"
export const CLEAR_CANDIDATEBOARD_FOR_CANDIDATE = "CLEAR_CANDIDATEBOARD_FOR_CANDIDATE"


// WEBPACK FOOTER //
// ./src/actionTypes/candidateBoard.js